import { html } from "../base/_utils.js";

export const staff = [
    /* ******************** ADMINISTRATION ******************** */
    // Haven Fields
    {
        id: "havenFields",
        dept: "admin",
        image: "assets/media/pages/about-us/staff/haven-fields.webp",
        name: "Haven Fields",
        title: "Deputy AD - Chief Operating Officer",
        modalTitle: "Deputy Athletic Director - Chief Operating Officer",
        email: "nebraska@huskers.com",
        phone: "402-472-3011",
        bio: html`
            <p>Haven Fields joined Nebraska Athletics as the Deputy Athletic Director/Chief Operating Officer in April of 2024.</p>
            <p>
                Fields will serve as the day-to-day football administrator, assisting Head Coach Matt Rhule and his football staff. In addition to his role with the football program, Fields will
                oversee the Huskers Athletic Fund team and assist Dannen in managing the day-to-day operations of the athletic department.
            </p>
            <p>
                Fields comes to Lincoln after joining Dannen's Washington staff in January. With the Huskies, Fields led several external units including Marketing and Fan Engagement, Strategic
                Communications, Creative and Digital Services, Multimedia, and served as the Liaison for Learfield/Huskies Sports Properties. Fields also played a role in assisting with the Huskies'
                transition to the Big Ten with oversight of the Broadcast Operations that produces a plethora of video productions.
            </p>
            <p>
                Fields was the Football Sport Administrator for the 2024 College Football Playoff National Runner-Up and 2023 Pac-12 Champions. During his time at UW, Fields assisted in the hiring of
                new Head Football Coach Jedd Fisch and Head Men's Basketball Coach Danny Sprinkle.
            </p>
            <p>
                Before his appointment at Washington, Fields was the Deputy Athletics Director at Ball State University as the number two administrator in the department. He assisted in supervising
                the Cardinals' 19 teams and 450-plus student-athletes. Fields oversaw several external areas (Athletics Communications, Marketing & Fan Engagement, Development, Ticketing Sales &
                Operations, and was the liaison to Learfield-IMG/Ball State Sports Properties).
            </p>
            <p>
                Several of the team's Fields worked with experienced record success from a revenue generation standpoint. Specifically, he worked as the sport administrator for the football and
                basketball programs. He administered the football program's first bowl game win in school history in 2020, beating two top-25 opponents in that season. Ball State finished the year
                ranked in the AP Top 25 and made back-to-back bowl appearances for only the third time in the school's history.
            </p>
            <p>
                Fields led Ball State's COVID-19 plan for return to campus, testing protocols that successfully allowed all programs to compete and finish their seasons. During his time at Ball State,
                he assisted in raising private support of more than $15 million and oversaw the athletic department's most notable capital project to date--The Scheumann Family Indoor Practice
                Facility, which was fully funded through private support.
            </p>
            <p>
                Prior to his time at Ball State, Fields worked at the University of Illinois as the Associate Athletic Director of Development. In his six years with the Illini, Fields assisted with
                the university's $2.25 billion “With Illinois” campaign, $300 million of which was earmarked for athletics. The university campaign exceeded $2.7 billion, and the athletics portion
                raised $321 million.
            </p>
            <p>
                Before his stint at Illinois, Fields worked at the University of South Alabama for over five years, where he assisted in the facilitation of the overall football operation for a
                start-up, Division I program, and transition to Football Bowl Subdivision. Fields began his time in collegiate athletics at Auburn, working for four years at his alma mater.
            </p>
            <p>
                Fields played collegiate football for Auburn, earning the Zeke Smith Award (Auburn's Defensive Player of the Year). He was an honorable mention All-SEC pick as a linebacker and earned
                a spot on the All-SEC Football Allstate “Good Works” Team. After college, Fields played two seasons of professional football in the Canadian Football League for the Hamilton Tigercats
                and British Columbia Lions.
            </p>
            <p>
                Fields earned his bachelor's degree in Kinesiology from Auburn in 2001 and later earned a master's in Higher Education Administration/Sports Management. He and his wife, Dr. Mya, who's
                an Assistant Dean for Purdue University's School of Multidisciplinary and Professional Studies have two sons, Haven Jr. and Hendrix.
            </p>
        `,
    },
    // Tyler Kai
    {
        id: "tylerKai",
        dept: "admin",
        image: "assets/media/pages/about-us/staff/tyler-kai.webp",
        name: "Tyler Kai",
        title: "Deputy AD - Revenue Generation",
        modalTitle: "Deputy Athletic Director - Revenue Generation",
        email: "tkai@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>
                Tyler Kai was promoted to Deputy AD for Revenue Generation in July of 2024. Kai has oversight of departmental revenue generation units including fundraising and ticket sales, service
                and operations. Additionally, Kai serves as the primary liaison to 1890 Nebraska and led the charge to an expanded partnership between 1890 and Husker Athletics that promoted Nebraska
                student-athletes NIL opportunities. During fiscal year 2025, Nebraska Athletics announced a record year in fundraising and ticket revenue under Kai's leadership. In the spring of 2025,
                Kai reorganized Husker Athletic Fund and introduced the newly formed revenue analytics and ticket sales units charged with unlocking and generating revenue potential for Nebraska
                Athletics.
            </p>
            <p>
                Kai joined the Nebraska Athletic Department in August of 2021 as the Associate AD of Leadership Gifts & Capital Projects for the Huskers Athletic Fund. He led the overall major gift
                program for capital projects and endowments, securing major gift commitments from Husker supporters. In the Spring of 2023, Kai directed enhancements to the Nebraska Leadership Society
                including a rebranding, the introduction of new recognition levels, and enhanced member benefits to better serve the generous supporters of Nebraska Athletics.
            </p>
            <p>
                Kai came to Nebraska from Tulane, where he served as the Associate AD for Development. He oversaw the Green Wave Club and Ticket Office, while creating the departmental fundraising and
                revenue generation strategy and setting annual goals. He also led the department's fundraising effort by securing significant gift commitments for department priorities, including the
                Slatten Family Strength Center and Don & Lora Peters Academic Center renovations. Kai joined Tulane in March of 2017 to lead the day-to-day operations of the athletics annual fund
                including donor relations, stewardship and fundraising initiatives. The Green Wave Club's membership and donations grew to record highs, under Kai's leadership. In 2019, Kai led a
                comprehensive effort to refine Tulane's priority seating model in Yulman Stadium, Avron B. Fogelman Arena in the Devlin Fieldhouse and Greer Field at Turchin Stadium.
            </p>
            <p>
                Prior to Tulane, Kai served as the Assistant Director of Campaigns for the University of Tennessee. His primary role was identifying, cultivating and soliciting major gifts to benefit
                the athletics programs. During his term, the Tennessee Fund reached record years in annual giving, sold out of season tickets at Neyland Stadium, and surpassed a three-year campaign
                goal of $147.5 million.
            </p>
            <p>
                Kai earned a Bachelor of Science degree from Iowa State University and a Master of Science degree from Kansas State University. Tyler and his wife, Caitlin, have two children -
                Harrison and Liam. Kai was born in Pender, Neb and raised in Urbandale, Iowa.
            </p>
        `,
    },
    // Katie Elliott
    {
        id: "katieElliott",
        dept: "admin",
        image: "assets/media/pages/about-us/staff/katie-elliott.webp",
        name: "Katie Elliott",
        title: "Administrative Assistant",
        email: "kelliott13@huskers.com",
        phone: "402-472-9839",
        bio: html`
            <p>
                Katie Elliott joined Nebraska Athletics in October 2024 as an Administrative Assistant, supporting the Huskers Athletic Fund and the Nebraska Athletics Ticket Office. Elliott provides
                comprehensive administrative support to these areas including coordinating travel, processing expense reimbursements and invoices and project management. In addition, Elliott assists
                the Deputy AD for Revenue Generation with calendar management and data entry.
            </p>
            <p>
                Prior to her time with the Huskers Athletic Fund team, Elliott worked at the Nebraska Department of Correctional Services in various roles, including custody, Human Resources, and
                Recreation. For the last four years of her tenure there, she was the Recreation Manager, overseeing programs such as athletics, music, art, movies and cultural events, while also
                implementing a reward system. Elliott developed policies and procedures to ensure compliance with administrative regulations and accreditation standards. Elliott assessed the needs and
                interests of all stakeholders to support program planning and budget preparation.
            </p>
            <p>
                Elliott graduated from the University of Nebraska at Kearney in May 2013 with a degree in sports and business administration. She lives in Lincoln, Nebraska, with her husband, Keith;
                stepson, Nolan; daughter, Lauren; and son, Logan.
            </p>
        `,
    },
    /* ******************** ANNUAL FUND ******************** */
    // Ben Kewman
    {
        id: "benKewman",
        dept: "annualFund",
        image: "assets/media/pages/about-us/staff/ben-kewman.webp",
        name: "Ben Kewman",
        title: "Associate AD - Development",
        modalTitle: "Associate Athletic Director - Development",
        email: "bkewman2@huskers.com",
        // MarkUp #7 / MarkUp #11
        phone: "402-472-2714",
        bio: html`
            <p>Ben Kewman joined Nebraska Athletics in September of 2024 as the Associate Athletic Director of Development for Huskers Athletic Fund.</p>
            <p>
                Kewman provides oversight of Annual Giving and Premium Seating while also cultivating relationships with Husker supporters across the country, to secure gift commitments for capital
                projects, endowments and current-use funds.
            </p>
            <p>
                Kewman came to Nebraska from Purdue University, where he served most recently as the Assistant Athletics Director for Annual Giving and Premium Seating. Kewman helped grow annual
                giving revenues by nearly 250% and contributed to multiple record-breaking years as part of the John Purdue Club team. Kewman also contributed to the department's fundraising efforts
                by securing significant gift commitments for department priorities, including the Purdue Football Master Plan, Ross-Ade Stadium Renovation, More Than a Game Campaign, Forging Ahead
                Campaign and Mackey Arena Renovations.
            </p>
            <p>
                Kewman earned a Bachelor's degree in Management from Purdue University's Mitch Daniels School of Business in 2011. Ben and his wife, Katlyn, have three daughters - Jane, Rose and Ella.
                Kewman claims both Ann Arbor, Michigan and Nevada City, California as his hometowns.
            </p>
        `,
    },
    // Katie Glover
    {
        id: "katieGlover",
        dept: "annualFund",
        image: "assets/media/pages/about-us/staff/katie-glover.webp",
        name: "Katie Glover",
        title: "Associate Director of Annual Giving",
        email: "kglover@huskers.com",
        phone: "402-472-0320",
        bio: html`
            <p>
                Katie Glover joined the Nebraska Athletic Department in June of 2022 as the Assistant Director of Annual Giving and was promoted to Associate Director of Annual Giving in January of
                2026.
            </p>
            <p>
                In her current role, Glover supports the growth of Huskers Athletic Fund membership and the annual fund by managing the annual contribution renewal process and leading athletics
                efforts for the University’s annual day of giving. Glover is responsible for the creation and execution of Huskers Athletic Fund donor communications, digital fundraising campaigns,
                and strategies that enhance the giving experience for current and prospective supporters.
            </p>
            <p>
                Prior to Nebraska, Glover was an athletic academic advising graduate assistant for the LAKER Academic Success Center at Grand Valley State University. Here, Glover provided academic
                advising, personal skill development support and individualized learning strategies to student-athletes.
            </p>
            <p>
                A native of Sioux City, Iowa, Glover earned her bachelor's degree in business administration and sports management with a minor in legal studies from Briar Cliff University in 2020.
                Glover completed her M.Ed. with an emphasis in College Student Affairs Leadership from Grand Valley State University in 2022.
            </p>
        `,
    },
    // Trevor Acton
    {
        id: "trevorActon",
        dept: "annualFund",
        image: "assets/media/pages/about-us/staff/trevor-acton.webp",
        name: "Trevor Acton",
        title: "Assistant Director of Annual Giving (N Club)",
        email: "tacton3@huskers.com",
        phone: "402-472-2614",
        bio: html`
            <p>
                Trevor Acton joined Nebraska Athletics in May 2025 as the Assistant Director of Annual Giving (N-Club). Acton is responsible for securing donor support, assisting the Husker Athletic
                Fund leadership team with assigned projects and internal operations tasks and focuses on sport-specific giving and athletics alumni relations.
            </p>
            <p>
                Acton joins the Huskers after being a member of the Husker Track and Field and Cross Country teams. During his time as a Husker student-athlete, Acton served as a team captain, team
                representative for the Student-Athlete Advisory Committee, was an intern for the Huskers Athletic Fund and was a graduate assistant for the College of Business Career Center.
            </p>
            <p>
                As a student-athlete, Acton earned numerous awards including Academic All-Big Ten, Big Ten Sportsmanship Award, Nebraska Scholar-Athlete Honor Roll, Tom Osborne Citizenship Team and
                Sam Foltz 27 Hero Leadership Award honors.
            </p>
            <p>Acton earned his bachelor's degree in business administration in May 2024 and is set to graduate in May 2026 with his master's of science in educational administration.</p>
        `,
    },
    // Jack Moorman-Wolfe
    {
        id: "jackMoormanWolfe",
        dept: "annualFund",
        image: "assets/media/pages/about-us/staff/jack-moorman-wolfe.webp",
        name: "Jack Moorman-Wolfe",
        title: "Assistant Director of Annual Giving",
        email: "jmoorman-wolfe2@huskers.com",
        phone: "402-472-6181",
        bio: html`
            <p>
                Jack Moorman-Wolfe joined Nebraska Athletics as the Assistant Director of Annual Giving in June 2025. He is responsible for securing and growing philanthropic support toward the
                Huskers Athletic Fund, primarily through priority seating renewals and annual fund contributions. Moorman-Wolfe also engages a portfolio of individuals, corporations and foundations to
                secure leadership annual, capital, endowment, and planned gifts for the benefit of Nebraska Athletics, its student-athletes, supporters, and strategic priorities.
            </p>
            <p>
                Prior to the Huskers, Moorman-Wolfe served as a Development Intern for the TCU Frog Club from 2023-2025, gaining a breadth of experience in revenue generation and development by
                working closely with Frog Club's annual fund, major gifts, communications, and hospitality units. He helped facilitate various initiatives including soliciting and acquiring new
                capital gift pledge commitments, fulfilling existing and overdue pledge installments, and managing a comprehensive stewardship communications strategy on behalf of department
                leadership.
            </p>
            <p>Jack, a native of Bloomington, Illinois, graduated from TCU in 2025 with a bachelor's degree in political science.</p>
        `,
    },
    /* ******************** DONOR EXPERIENCE ******************** */
    // Larisa Hart
    {
        id: "larisaHart",
        dept: "donorExp",
        image: "assets/media/pages/about-us/staff/larisa-hart.webp",
        name: "Larisa Hart",
        title: "Senior Director of Donor Experience",
        email: "lhart@huskers.com",
        phone: "402-472-8715",
        bio: html`
            <p>
                Larisa Hart joined the Nebraska Athletic Department in July 2023 and was promoted to Senior Director of Donor Experience in January 2025. Prior to her promotion, she served as the
                Director of Premium Seating & Hospitality.
            </p>
            <p>
                In her current role, Hart oversees premium seating and hospitality, donor stewardship, and donor events for Nebraska Athletics. She collaborates closely with the development team to
                ensure Husker fans and Huskers Athletic Fund donors enjoy exceptional experiences in their interactions with Nebraska Athletics.
            </p>
            <p>
                Hart brings extensive experience in premium seating and hospitality, having worked with both REVELxp, a former affiliate of Nebraska Athletics, and Pinnacle Bank Arena. While at
                REVELxp, she delivered top-tier service for Husker premium areas and was selected to manage suites and pregame VIP experiences for the 2022 Big Ten Football Championship, as well as
                the 2022 and 2023 Big Ten Men's Basketball Tournaments. At Pinnacle Bank Arena, Hart served as the Premium Services and Catering Supervisor, overseeing onsite hospitality operations
                for Husker Basketball, concerts, and conventions, while managing staff in the arena's premium seating areas.
            </p>
            <p>
                Hart earned her bachelor's degree in Hospitality, Tourism & Event Management from the University of Nebraska-Lincoln in 2015 and is proud to work at her alma mater in her current role.
            </p>
        `,
    },
    // Lydia Granahan
    {
        id: "lydiaGranahan",
        dept: "donorExp",
        image: "assets/media/pages/about-us/staff/lydia-granahan.webp",
        name: "Lydia Granahan",
        title: "Director of Donor Experience",
        email: "lgranahan@huskers.com",
        phone: "402-472-8583",
        bio: html`
            <p>
                Lydia Granahan joined the Nebraska Athletics Department in July 2023 and was promoted to Director of Donor Experience in January 2026. Prior to her promotion, she served as the
                Assistant Director of Premium Seating & Hospitality. She began with the Huskers Athletic Fund as an affiliate through RevelXP as the Assistant Hospitality Manager in August 2022.
            </p>
            <p>
                Currently, Granahan coordinates all events and stewardship efforts to enhance member experience for donors of Nebraska Athletics. Additionally, she continues to oversee hospitality and
                event interns for the Huskers Athletic Fund in order to deliver the best-in-class experiences on game day and beyond.
            </p>
            <p>
                Prior to joining the HAF team, Granahan interned at the Academy of Country Music on the events team to gain experience in the entertainment industry through the ACM Awards. Since then,
                she continues to work with the ACM team for the week of show as a Talent & Production Manager. While earning her master's degree, Granahan worked at Achieve Physical Therapy - Sports
                Training in Bellevue, Nebraska as an administrative assistant overseeing internal and external office operations including managing community events and company marketing.
            </p>
            <p>Granahan earned both her bachelor's degree and master's degree in Event Management from Iowa State University in 2020 and 2021 respectively.</p>
        `,
    },
    // Kaitlyn Conant
    {
        id: "kaitlynConant",
        dept: "donorExp",
        image: "assets/media/pages/about-us/staff/kaitlyn-schmeling.webp",
        name: "Kaitlyn Conant",
        title: "Assistant Director of Donor Experience",
        email: "kschmeling2@huskers.com",
        phone: "402-472-2520",
        bio: html`
            <p>
                Kaitlyn Conant serves as the Assistant Director of Donor Experience, a role she proudly stepped into following her promotion in December 2025. She began her journey with the Huskers
                Athletic Fund as an intern, gaining two years of hands-on experience while completing her studies at the University of Nebraska-Lincoln. Her early involvement within the athletic
                department helped spark her passion for donor engagement, hospitality, and elevating the fan experience.
            </p>
            <p>
                In her current role, Conant oversees premium seating hospitality for Husker Football, Volleyball, Basketball, Wrestling, and Gymnastics. She partners closely with the Huskers Athletic
                Fund development team to curate memorable game-day environments, ensuring that every fan and donor feels valued and connected to the Husker community. Her commitment to service,
                attention to detail, and enthusiasm for Nebraska Athletics continue to shape the experience of thousands of guests each season.
            </p>
            <p>
                Conant earned her bachelor's degree in Sports Media & Mass Communications with a minor in Psychology from the University of Nebraska-Lincoln in 2025. A proud alum, she is grateful for
                the opportunity to contribute to the university that has played such a meaningful role in her personal and professional growth.
            </p>
        `,
    },
    // Breanna Bosshamer
    {
        id: "breannaBosshamer",
        dept: "donorExp",
        image: "assets/media/pages/about-us/staff/breanna-bosshmer.webp",
        // MarkUp #19
        name: "Breanna Bosshamer",
        title: "Donor Experience Coordinator",
        email: "donorexperience@huskers.com",
        phone: "402-472-3111",
    },
    // Jenna Carlson
    {
        id: "jennaCarlson",
        dept: "donorExp",
        image: "assets/media/pages/about-us/staff/jenna-carlson.webp",
        name: "Jenna Carlson",
        title: "Donor Experience Coordinator",
        email: "donorexperience@huskers.com",
        phone: "402-472-3111",
    },
    /* ******************** INTERNAL OPERATIONS ******************** */
    // Derek Freeman
    {
        id: "derekFreeman",
        dept: "internalOps",
        image: "assets/media/pages/about-us/staff/derek-freeman.webp",
        name: "Derek Freeman",
        title: "Senior Associate AD - Development",
        modalTitle: "Senior Associate Athletic Director - Development",
        email: "dfreeman@huskers.com",
        phone: "402-472-0796",
        bio: html`
            <p>
                Derek Freeman was promoted to Senior Associate Athletic Director for Development in November 2023. Freeman leads and manages the internal operations of the athletics development and
                ticket office. He is responsible for raising gifts to support the mission, vision and strategic plan of the University of Nebraska-Lincoln and will focus on the cultivation,
                solicitation, and stewardship of identified athletics donors.
            </p>
            <p>
                Freeman has been a member of Nebraska Athletic Development since September 1998 and has held many roles. Most recently, Freeman was an Assistant AD for Internal Operations. Freeman's
                responsibilities have included cultivating donor relations with the University's top donors, managing all contributions to Nebraska Athletics including the Go Big capital campaign,
                supervising the online seat selection process (Seat Yourself), allocating parking for most ticketed sports, and providing the reporting and analytics for the Huskers Athletic Fund.
            </p>
            <p>
                A native of Lincoln, Freeman earned a Bachelor of Science degree in business administration with an emphasis in management from Nebraska in May 1998. Married to the former Lindsey
                Soukup, Freeman and his wife have two sons, Brody and Gavin, and one daughter, Blake.
            </p>
        `,
    },
    // Ian Ousley
    // MarkUp #14
    {
        id: "ianOusley",
        dept: "internalOps",
        image: "assets/media/pages/about-us/staff/ian-ousley.webp",
        name: "Ian Ousley",
        title: "Senior Director of Business Intelligence - Development & Ticketing",
        email: "iousley@huskers.com",
        phone: "402-472-9158",
        bio: html`
            <p>
                Ian Ousley serves as the Senior Director of Business Intelligence – Development & Ticketing, having been promoted in April of 2024. He originally joined the Nebraska Athletic
                Department as Director of Development in June of 2022.
            </p>
            <p>
                His current responsibilities include leadership of initiatives that leverage data to enhance development and ticketing operations, serving as the liaison with various departments, and
                building strong relationships with donors to secure gift commitments for key fundraising priorities.
            </p>
            <p>
                As Director of Development, Ousley was responsible for fostering relationships with donors in Nebraska and the Great Lakes region, and secured gift commitments for capital projects,
                endowments, planned gifts, and current-use funds.
            </p>
            <p>
                Ousley came to Nebraska after previously serving as Assistant Director of Development, Major Gifts at Penn State's Smeal College of Business for four years from 2018-2022. He was
                responsible for the major gifts fundraising efforts in Western Pennsylvania, Arizona, and portions of the Midwest. He also led a comprehensive redesign of the unit's Giving Day
                strategy, resulting in successive records in participation and donations. During his tenure, the Smeal College raised record-breaking support that totaled over $95 million as part of
                the successful $2.2 billion university-wide campaign, A Greater Penn State.
            </p>
            <p>
                Before Penn State, Ousley was a Development & Operations Coordinator for the Army A Club in 2015-2016 at Army West Point, where a record-breaking $5.6 million in annual support was
                raised during his time with the Black Knights. He also served as an Athletics Development Graduate Assistant at Ohio from 2016-2018 and assisted in producing a record total in annual
                contributions.
            </p>
            <p>
                A member of the Nebraska wrestling program from 2011-2015, Ousley graduated from Nebraska with a bachelor's degree in nutrition, exercise, and health science and obtained a pair of
                master's degrees in business administration and sport administration from Ohio.
            </p>
            <p>The Saginaw, Mich., native married former Husker swimmer Ciara Jenkins. The couple lives in Lincoln with their two dogs.</p>
        `,
    },
    // Jack Yelden
    {
        id: "jackYelden",
        dept: "internalOps",
        image: "assets/media/pages/about-us/staff/jack-yelden.webp",
        name: "Jack Yelden",
        title: "Assistant Director of Revenue Analytics",
        email: "jyelden@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>
                Jack Yelden serves as the Assistant Director of Revenue Analytics, having been promoted in April of 2025. He originally joined the Nebraska Athletic Department as Assistant Ticket
                Manager in July of 2023. Yelden currently assists with reporting and analyzing data to enhance development and ticketing operations.
            </p>
            <p>Yelden previously worked in the Nebraska Athletic Ticket Office as a student while pursuing his degree at the University of Nebraska-Lincoln.</p>
            <p>Originally from Seward, Neb., Yelden graduated in May 2023 with a degree in sports media & communication and a mathematics minor.</p>
        `,
    },
    // Jenni Puchalla
    {
        id: "jenniPuchalla",
        dept: "internalOps",
        image: "assets/media/pages/about-us/staff/jenni-puchalla-25.webp",
        name: "Jenni Puchalla",
        title: "Associate Operations Manager",
        email: "jpuchalla@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>
                Jenni Puchalla joined Nebraska Athletics in 2009. She currently serves as the Associate Operations Manager. In her current role, she works with donors and season ticket holders on a
                daily basis, while supervising student-workers in the Development and Ticketing Office.
            </p>
            <p>Originally from Norfolk, Neb., Puchalla earned both her bachelor's and master's degrees in English from the University of Nebraska. She has two sons.</p>
        `,
    },
    // Karen Williamson Conway
    {
        id: "karenWilliamsonConway",
        dept: "internalOps",
        image: "assets/media/pages/about-us/staff/karen-williamson-conway.webp",
        name: "Karen Williamson Conway",
        title: "Associate Operations Manager",
        email: "kwilliamson@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>Karen Williamson Conway serves as an associate ticket manager after joining the Nebraska Athletic Department staff in October of 2005.</p>
            <p>
                In her current role, Williamson Conway is involved with day-to-day ticket operations, including receiving and inputting ticket payments, preparing and balancing event seller sheets,
                processing complimentary ticket requests and reports and overseeing the disability seating at Nebraska's athletic events.
            </p>
            <p>Williamson Conway previously spent four years as a special education para-educator with the Lincoln Public Schools. She also operated her own childcare business for 10 years.</p>
            <p>
                Williamson Conway is a native of Waverly, Neb., and has lived in Lincoln since attending the University of Nebraska. She earned her bachelor's degree in consumer science and family
                resources from Nebraska in 1985. Karen and her husband, Joe, have five sons, Ben, Nate, Brendan, Nolan and Dylan.
            </p>
        `,
    },
    /* ******************** LEADERSHIP GIFTS ******************** */
    // Blake Day
    {
        id: "blakeDay",
        dept: "leadershipGifts",
        image: "assets/media/pages/about-us/staff/blake-day-25.webp",
        name: "Blake Day",
        title: "Associate AD - Leadership Gifts",
        modalTitle: "Associate Athletic Director - Leadership Gifts",
        email: "bday6@huskers.com",
        // MarkUp #6 / MarkUp #11
        phone: "402-472-4305",
        bio: html`
            <p>
                Blake Day joined Nebraska Athletics in April 2025 as the Associate AD of Leadership Gifts. Day provides oversight for the Huskers leadership gifts team and directs and develops plans
                to maximize fundraising revenue in concert with strategic priorities and objectives.
            </p>
            <p>
                Day joins Nebraska after serving as the Senior Vice President for the Northern State University Foundation in Aberdeen, South Dakota, from July 2021-April 2025. In this role, Day led
                the NSU Foundation's overall development efforts, while managing principal and leadership level fundraising activities to raise private support for NSU.
            </p>
            <p>
                Prior to NSU, Day served his alma mater, South Dakota State University, where he worked as Associate Athletic Director for Development, leading development efforts for Jackrabbit
                Athletics since 2017, including annual giving, major gifts, special events, hospitality efforts, and various fundraising initiatives.
            </p>
            <p>Day also spent time in development roles at the University of Texas Rio Grande Valley in Edinburg, Texas, and Northern State University in Aberdeen, South Dakota.</p>
            <p>Blake, a native of Winner, South Dakota, earned his bachelor's degree in business economics as well as his master's degree in sport and recreation studies from South Dakota State.</p>
        `,
    },
    // Brenden Stai
    {
        id: "brendenStai",
        dept: "leadershipGifts",
        image: "assets/media/pages/about-us/staff/brenden-stai.webp",
        name: "Brenden Stai",
        title: "Assistant AD - Leadership Giving & Football Relations",
        modalTitle: "Assistant Athletic Director - Leadership Giving & Football Relations",
        email: "bstai@huskers.com",
        // MarkUp #8 / MarkUp #11
        phone: "402-472-0918",
        bio: html`
            <p>
                Brenden Stai joined the Nebraska Athletic Department in July of 2018 as a Director of Development, and he was promoted to Assistant Athletic Director - Leadership Giving & Football
                Relations in 2022. As a member of the Huskers Athletic Fund (HAF), Stai is responsible for fostering relationships with donors in the state of Nebraska and throughout the United
                States. Since joining the Husker Athletic Fund, Stai has been an instrumental part of multiple fundraising efforts, including but not limited to the Osborne Legacy Complex.
            </p>
            <p>
                A native of Yorba Linda, Calif., Brenden has a deep connection with Nebraska as he was recruited to play football by Tom Osborne. Stai started his Husker career in 1990 and left after
                his senior season in 1994. Brenden was a Consensus All-American & 1st Team All-Big 8 Offensive Lineman for the 1994 National Championship Cornhuskers.
            </p>
            <p>
                Stai was then selected in the 3rd round of the 1995 National Football League (NFL) draft by the Pittsburgh Steelers (1995 AFC Championship team; Super Bowl XXX; 1995 NFL All Rookie
                Team) and enjoyed a 9 year professional football career (3 years as a NFL Players Association (NFLPA) representative).
            </p>
            <p>After his playing days, Brenden spent 10 years in coaching (College, Junior College and High School) and 10 years in both the private business sector and real estate.</p>
            <p>Brenden, and his wife Jennifer, have three children, Christina, Bryce and Brianna and a granddaughter, Lucy! The Stais have called Lincoln home for the past 17 years.</p>
        `,
    },
    // Kyle Bollig
    {
        id: "kyleBollig",
        dept: "leadershipGifts",
        image: "assets/media/pages/about-us/staff/kyle-bollig.webp",
        name: "Kyle Bollig",
        title: "Associate Director of Leadership Gifts",
        email: "kbollig@huskers.com",
        // MarkUp #9 / MarkUp #11
        phone: "402-472-2440",
        bio: html`
            <p>
                Kyle Bollig joined the Nebraska Athletic Department as an Assistant Director of Leadership Gifts in July of 2022. Bollig was promoted to Associate Director of Leadership Gifts in June
                of 2024.
            </p>
            <p>
                In his current role, Bollig is responsible for advancing relationships with Husker supporters across the country to secure gift commitments for capital projects and current-use funds.
                Bollig works with supporters across the state of Nebraska, as well as Kansas City, Denver, and other regional areas.
            </p>
            <p>
                Prior to Nebraska, Bollig served as Assistant Director of Development for the Green Wave Club at Tulane. In his role, Bollig coordinated priority seating renewal efforts and the
                execution of the department's 24-hour Giving Day.
            </p>
            <p>
                Before Tulane, Bollig worked as an Alumni Engagement graduate assistant for the College of Business and an External Operations graduate assistant for the athletic department at Ohio.
                As a student at Kansas, he served as a student worker for three years in equipment services for Kansas Athletics.
            </p>
            <p>
                A native of Olathe, Kan., Bollig received his bachelor's degree in business marketing from Kansas in 2019. Bollig earned master's degrees in business administration and sports
                administration from Ohio in 2021.
            </p>
        `,
    },
    // Murphy Maurer
    {
        id: "murphyMaurer",
        dept: "leadershipGifts",
        image: "assets/media/pages/about-us/staff/murphy-maurer.webp",
        name: "Murphy Maurer",
        title: "Associate Director of Leadership Gifts",
        email: "mmaurer5@huskers.com",
        // MarkUp #10 / MarkUp #11
        phone: "402-469-9297",
        bio: html`
            <p>Murphy Maurer joined the Nebraska Athletic Department as an Associate Director of Leadership Gifts in August of 2024.</p>
            <p>
                In her current role, Maurer is responsible for advancing relationships with Husker supporters across the country, to secure gift commitments for capital projects, endowments, and
                current-use funds.
            </p>
            <p>
                Prior to Nebraska, Maurer served as the Director of Corporate Partnerships for the Omaha Supernovas, a professional volleyball team that competes in the Pro Volleyball Federation. In
                her role with the Supernovas, Maurer was responsible for initiating and maintaining relationships with the team's corporate partners during the inaugural season.
            </p>
            <p>
                Maurer, a native of Hastings, Nebraska, received her bachelor's degree in sports media and communication from the University of Nebraska - Lincoln in 2020. She worked as a marketing
                and fan experience intern for Nebraska Athletics in 2019-20. From there, she went on to earn a master's degree in organizational leadership from Creighton University, where she worked
                as a graduate assistant in the athletic department for two years.
            </p>
        `,
    },
    /* ****************** PREMIUM SALES ****************** */
    // James Armold
    {
        id: "jamesArmold",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/james-arnold.webp",
        name: "James Armold",
        title: "Senior Vice President, Project Lead",
        email: "jarmold2@huskers.com",
        phone: "402-472-4307",
        bio: html` <p>
                James Armold joined Nebraska Athletics in May of 2026, serving as Project Lead for the Big Red Rebuild. In his role, Armold supports Nebraska Athletics and the Huskers Athletic Fund on
                the transformation of Memorial Stadium’s premium seating experience.
            </p>
            <p>
                Armold joined the Nebraska Athletics after spending more than 13 years with D.C. United, most recently serving as Senior Vice President of Revenue. In that role, he oversaw ticketing,
                corporate partnerships, events, owned soccer and sporting events, and youth programs. During his tenure, Armold helped lead the club’s transition from RFK Stadium to Audi Field,
                including the opening of the new stadium in 2018 and its continued growth as a sports and entertainment venue.
            </p>
            <p>
                A native of Altoona, Pennsylvania, and raised in Spotsylvania, Virginia, Armold earned both a Bachelor of Science in Kinesiology with a concentration in Sport and Recreation Management
                in 2009 and a Master of Science in Hospitality, Sport and Recreation Management in 2010 from James Madison University. He and his wife, Paige, have two sons, Patrick and Benjamin, and
                a dog, Quinn.
            </p>`,
    },

    // Jason Matteson
    {
        id: "jasonMatteson",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/jason-matteson.webp",
        name: "Jason Matteson",
        title: "Senior Director, Sales",
        email: "jmatteson2@huskers.com",
        phone: "402-472-4359",
        bio: html` <p>
                Jason Matteson joined Nebraska Athletics in July of 2026 as the Senior Director, Sales. In his role, Matteson helps oversee the introduction of new premium seating experiences coming
                to Memorial Stadium through the Big Red Rebuild.
            </p>
            <p>
                Matteson came to Nebraska from UNC Charlotte where he served as Senior Sales Director overseeing premium sales efforts for a transformational renovation to their football stadium.
                Prior to Charlotte, Matteson spent 6 years at the University of Kansas where he helped bring new premium experiences to David Booth Kansas Memorial Stadium and the opening of the
                Gateway District Project.
            </p>
            <p>
                Born and raised in Morris, IL, Matteson earned his bachelor’s degree in Sport and Recreation Management from the University of Iowa in 2017. He and his wife, Ryan, reside in Lincoln
                with their dog Bear.
            </p>`,
    },

    // Tawanda Mwedziwendira
    {
        id: "tawandaMwedziwendira",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/tawanda-mwedziwendira.webp",
        name: "Tawanda Mwedziwendira",
        title: "Senior Premium Sales Manager",
        email: "tmwedziwendira@huskers.com",
        phone: "402-472-4349",
        bio: html` <p>Tawanda Mwedziwendira joined Nebraska Athletics as Senior Premium Sales Manager in August of 2026 supporting the Big Red Rebuild project.</p>
            <p>
                Prior to joining Nebraska, Mwedziwendira served as Premium Sales Manager at Northwestern University in Evanston, IL, where he contributed to premium seating sales efforts for the New
                Ryan Field stadium project. Mwedziwendira played a key role in supporting the premium seating on-sale for the new stadium, contributing to donor engagement across a multimillion-dollar
                capital portfolio. He drove strong capital gift and annual term length revenue growth through disciplined pipeline management and strategic donor outreach, while also leading a new
                sales training program for Annual Ticketing Account Executives, an effort that helped four team members earn promotions to Premium Account Executive roles.
            </p>
            <p>
                Before Northwestern, Mwedziwendira served as Premium Sales Manager at the University of Kansas, where he contributed to premium seating sales for the David Booth Kansas Memorial
                Stadium Project. In this role, Mwedziwendira drove significant combined capital and annual revenue growth across major gifts, annual payments, and Williams Education Fund
                contributions, while collaborating closely with athletic development and advancement teams to align sales activity with institutional fundraising goals.
            </p>
            <p>
                Mwedziwendira began his career in the sports industry with the Dallas Cowboys as a Suite Sales & Service Intern at AT&T Stadium, later transitioning into a full-time role as Account
                Executive, Group Sales for AT&T Stadium, There, Mwedziwendira consistently exceeded revenue goals while managing group sales accounts and coordinating field rental events. His early
                experience included supporting premium hospitality operations for Dallas Cowboys home games and marquee events such as the Big 12 Championship, Southwest Classic, and the Goodyear
                Cotton Bowl.
            </p>
            <p>Mwedziwendira holds a B.S. in Recreation and Sports Management from the University of Arkansas.</p>
            <p>
                Born in Harare, Zimbabwe, and raised in McKinney, Texas, Mwedziwendira now calls Lincoln, NE home. Outside of work, he enjoys cooking, cheering on the Dallas Cowboys, and spending
                quality time with family and friends.
            </p>`,
    },

    // Precious Birdsong-Kelly
    {
        id: "preciousbirdsongKelly",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/precious-birdsong-kelly.webp",
        name: "Precious Birdsong-Kelly",
        title: "Premium Sales Manager",
        email: "pbirdsong-kelly@huskers.com",
        phone: "402-472-4340",
        bio: html` <p>
                Precious Birdsong-Kelly joined Nebraska Athletics as Premium Sales Manager in August of 2026. In this role, Birdsong-Kelly supports premium seating sales and relationship development
                for the Big Red Rebuild project, helping create exceptional experiences for Nebraska Athletics fans, donors and stakeholders.
            </p>
            <p>
                Prior to Nebraska, Birdsong-Kelly spent five years at Vanderbilt University, most recently serving as Assistant Director of Development and Alumni Engagement for the National Commodore
                Club. In that role, she managed a portfolio of donors and prospects and raised more than $2 million in philanthropic support for Vanderbilt Athletics priorities. She also led alumni
                engagement efforts for several Vanderbilt sport programs, including football, women’s basketball, women’s soccer and track & field/cross country.
            </p>
            <p>
                Birdsong-Kelly began her Vanderbilt tenure in 2021 as Assistant Director of Facilities and Event Management, overseeing the day-to-day operations of the Currey Tennis Center and
                Vanderbilt Outdoor Track and serving as an event manager for multiple varsity sports. Before Vanderbilt, she served as Assistant Director of Facilities and Game Operations at the
                University of Arkansas at Little Rock, where she supported game-day operations across the department’s varsity sport programs.
            </p>
            <p>
                Birdsong-Kelly is an active member of the National Association of Collegiate Directors of Athletics, where she previously served as an intern. She is also a member of Women Leaders in
                Sports, the Collegiate Event and Facility Management Association and the Minority Opportunities Athletic Association, where she has served on the External Relations Committee and is a
                2021 graduate of the Rising Stars Program.
            </p>
            <p>
                A former collegiate and professional softball player, Birdsong-Kelly is a two-time graduate of Middle Tennessee State University. She earned her bachelor’s degree in leisure, sport and
                tourism studies in 2018 and her master’s degree in sport management in 2019. She also became the first player in MTSU softball history to be drafted to a professional softball league.
            </p>
            <p>
                A Chattanooga, Tennessee, native, Birdsong-Kelly holds a doctor of education in higher education leadership and policy from Vanderbilt University. She is also the founder and executive
                director of the Precious Birdsong Family Foundation, a nonprofit organization based in Chattanooga.
            </p>
            <p>Birdsong-Kelly currently resides in Lincoln with her husband, John.</p>`,
    },

    // Caymen Bishop
    {
        id: "caymenBishop",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/caymen-bishop.webp",
        name: "Caymen Bishop",
        title: "Premium Sales Manager",
        email: "caymenbishop@huskers.com",
        phone: "402-472-4347",
        bio: html` <p>Caymen Bishop joined Nebraska Athletics in August of 2026 as Premium Sales Manager supporting the Big Red Rebuild project.</p>
            <p>
                Prior to joining Nebraska, Bishop was hired as a Premium Suite Sales Executive with the Miami Hurricanes in February 2025, where he specialized in premium seating and suite sales for
                athletics, with a focus on football.
            </p>
            <p>Before joining Miami, Bishop was a Season Ticket Sales Account Executive with the Oklahoma City Thunder from 2022 to 2025, after starting with the Thunder in Inside Sales in 2021.</p>
            <p>
                While attending the University of Oklahoma, Bishop worked part-time as a Ticket Sales Associate with the Oklahoma City Thunder during the 2019-20 season and completed a Partnership
                Activation internship with the Oklahoma City Dodgers, the Triple-A affiliate of the Los Angeles Dodgers. During that time, he also served as an officer of the Sports Management Club.
            </p>
            <p>Bishop is from Oklahoma City, Oklahoma, and graduated from the University of Oklahoma in December 2020 with a bachelors in Political Science and a minor in History.</p>`,
    },

    // Mariana Cranford
    {
        id: "marianaCranford",
        dept: "premiumSales",
        image: "assets/media/pages/about-us/staff/mariana-cranford.webp",
        name: "Mariana Cranford",
        title: "Sales Coordinator",
        email: "mcranford@huskers.com",
        phone: "402-472-4314",
        bio: html` <p>
                Mariana Cranford joined the Nebraska Athletic Department in September 2026 as the Sales Coordinator. In her current role, she provides administrative, operational and marketing support
                to the Premium Sales Team, Senior Director and Senior Vice President.
            </p>
            <p>
                Prior to joining Nebraska, Cranford served as an Administrative Assistant at Liberty University in Lynchburg, Virginia, for two years. Cranford has previous experience as a Marketing
                and Events Coordinator for a small business and as a Social Media and Merchandising Coordinator for a minor league baseball team. She also gained experience in college athletics during
                her time at the University of Central Arkansas.
            </p>
            <p>
                A native of Little Rock, Arkansas, Cranford graduated from the University of Central Arkansas in 2021 with a bachelor's degree in exercise science and a minor in marketing. She earned
                her master's degree in sport management from the University of Central Arkansas in May 2023.
            </p>
            <p>Cranford currently resides in Lincoln with her husband, John, and their labradoodle, Presley.</p>`,
    },
    /* ******************** TICKETING ******************** */
    // Michael Stephens
    {
        id: "michaelStephens",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/michael-stephens.webp",
        name: "Michael Stephens",
        title: "Associate AD - Ticket Revenue",
        modalTitle: "Associate Athletic Director - Ticket Revenue",
        email: "mstephens2@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>
                Michael Stephens returned to the Nebraska Athletic Department on July 1, 2025, when he was hired as Associate Athletic Director - Ticket Revenue. Stephens previously worked on staff in
                marketing, ticket sales, licensing and concession operations roles from 2002 to 2014. The Nebraska native and NU graduate leads ticket sales strategy and has responsibility for the
                ticket office and the outbound ticket sales team. His position works in concert with the Husker Athletic Fund and the Husker Marketing Department to best serve our customers.
            </p>
            <p>
                Stephens came to Nebraska from the Nebraska Alumni Association, where he served as the Associate Executive Director - Operations. In that role, he managed business operations and led
                the Venues team that operates the Wick Alumni Center, the Nebraska Innovation Campus Conference Center, and the AKRS Champions Club. His Champions Club responsibilities included member
                relations and game day event management. Prior to the Alumni Association, Stephens was part of the team that built the Omaha Supernovas into a major professional franchise in their
                inaugural season. He led the ticket sales, sponsorship, and branding initiatives while also providing direction to the successful start-up as a member of the executive team. From the
                summer of 2014 to the spring of 2023, Stephens worked for Ohio University Athletics as the Senior Associate Athletic Director - External Operations. His stint at the Huskers was
                preceded by 10 years with the Royals Baseball organization - seven years in Omaha with the Triple-A club and three with the MLB club in Kansas City.
            </p>
            <p>
                Stephens earned a Bachelor of Science degree from the University of Nebraska and a Masters degree in Sport Management from Western Illinois University. Michael and his wife, Lisa, have
                two adult children - Trevor and Andrew.
            </p>
        `,
    },
    // Holly Adam
    {
        id: "hollyAdam",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/holly-adam.webp",
        name: "Holly Adam",
        title: "Assistant AD - Ticket Revenue",
        modalTitle: "Assistant Athletic Director - Ticket Revenue",
        email: "hadam@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>Holly Adam stepped into the role of Nebraska's Assistant Athletic Director for Ticketing in July of 2009, after previously serving as Nebraska's athletic ticket manager since 2004.</p>
            <p>
                Adam is the primary day-to-day contact for all ticketing issues and is responsible for all functions of Nebraska's ticket operations, including distribution and sales of tickets for
                all ticketed events.
            </p>
            <p>Adam oversees Nebraska's ticket office operation, as the staff works at more than 100 sporting events on campus each year, including conference and NCAA events.</p>
            <p>
                A native of Daykin, Neb., Adam joined the ticket office in 1995 and was promoted to assistant director in 1997. She served as the assistant director for eight years before being
                promoted to ticket manager in 2004.
            </p>
            <p>
                Adam graduated with a bachelor's degree in agricultural science from Nebraska in August 1997. Adam and her husband, Todd, have one son, Logan, and three daughters, Ashlyn, Jordyn and
                Camryn.
            </p>
        `,
    },
    // Angie Christ-Zemunski
    {
        id: "angieChristZemunski",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/angie-christ-zemunski.webp",
        name: "Angie Christ-Zemunski",
        title: "Director of Ticketing Intelligence Operations",
        email: "azemunski@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>
                Angie Christ-Zemunski joined the Nebraska Athletic Department in June of 2007 as an assistant ticket manager. She was promoted to director of ticketing intelligence operations in
                October of 2017.
            </p>
            <p>
                A native of Ft. Wayne, Ind., Christ-Zemunski joined the Husker athletic ticket office after spending 21 years as a customer service agent, trainer, supervisor and secretary for
                Northwest Airlines.
            </p>
            <p>
                Christ-Zemunski earned her associate's degree in business administration from Indiana Wesleyan in 2001. She is married to David Zemunski and has four children, Daniel, Sarah, Joel and
                Katelyn, and two grandchildren, Gavin and Harrison.
            </p>
        `,
    },
    // Jessica Green
    {
        id: "jessicaGreen",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/jessica-green.webp",
        name: "Jessica Green",
        title: "Director of Ticketing",
        email: "jgreen60@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>Jessica Green joined Nebraska Athletics as the Director of Ticketing in May of 2026.</p>
            <p>
                In her role, Green oversees the ticketing operations for Nebraska Volleyball, special events and other Husker sports. Green supports the development of sales and service strategies for
                Nebraska Athletics and works collaboratively across the department to help deliver an exceptional, seamless game day experience for Husker fans.
            </p>
            <p>
                Green joined Nebraska after nine years with Oak View Group. She spent the previous five years at Liberty First Credit Union Arena in Ralston, Nebraska as the Director of Ticketing and
                Marketing. Prior to her time in Ralston, Green worked at the Budweiser Events Center in Loveland, Colorado as an Assistant Box Office Manager.
            </p>
            <p>
                Green graduated from Colorado State University in 2016 with a bachelor’s degree in business administration with a minor in sports management. While at CSU, Green was a member of the
                track and field team. Green earned All-American honors finishing 22nd nationally in the heptathlon at the NCAA Division I Outdoor Championships. Green was the Outdoor Mountain West
                Conference Champion and an Academic All-Mountain West scholar-athlete. She was also part of the Colorado State Women’s Track and Field team that won three Mountain West conference
                titles.
            </p>
        `,
    },
    // Kristi Reetz
    {
        id: "kristiReetz",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/kristi-reetz.webp",
        name: "Kristi Reetz",
        title: "Director of Ticketing Operations",
        email: "kreetz@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>Kristi Reetz joined the Nebraska Athletic Department in 1994 as a staff assistant in the ticket office. She currently serves as the Director of Ticketing Operations.</p>
            <p>
                Reetz is responsible for all student-athlete, recruit and high school coach admissions, including football student-athlete ticket sign up and distribution for home and away football
                games. She also hires and manages all pass gate workers at home events, who are responsible for the distribution of complimentary tickets. Reetz also verifies and assigns all
                faculty/staff season ticket orders.
            </p>
            <p>Reetz, who is originally from Crete, Neb., earned her bachelor's degree from Nebraska in 1992.</p>
        `,
    },
    // Derrick Sheppard
    {
        id: "derrickSheppard",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/derrick-sheppard.webp",
        name: "Derrick Sheppard",
        title: "Director of Ticket Sales",
        email: "dsheppard4@huskers.com",
        phone: "402-472-5876",
        bio: html`
            <p>
                Derrick Sheppard joined Nebraska Athletics as the Director of Ticket Sales in August of 2025. In his role, Sheppard oversees the ticket sales and service teams for all ticketed Husker
                sports.
            </p>
            <p>
                Sheppard arrived in Lincoln following his time with Omaha Athletics, where he began as Assistant Athletic Director for Athletic Ticketing in July 2022 before being elevated to
                Associate Athletic Director in the spring of 2023. At Omaha, he led efforts related to season ticket sales, renewals, and the day-to-day operations for all ticketed Maverick athletic
                events.
            </p>
            <p>
                Prior to his time at Omaha, Sheppard spent five years with the University of South Dakota in various roles within the Coyote ticket office. Most recently, he guided the department as
                Director of Ticket Sales and Operations, managing all aspects of sales, renewals, and game day ticket operations. He previously held the position of Assistant Director of Ticket
                Operations for two seasons after beginning his career as a graduate assistant in 2018.
            </p>
            <p>
                A Fremont, Nebraska native, Sheppard earned a Bachelor of Arts degree from the University of Sioux Falls and a Master's degree in Sport Management from the University of South Dakota.
                He was a member of the track and field programs at both institutions.
            </p>
            <p>Sheppard is joined in Lincoln by his wife, Molly.</p>
        `,
    },

    // Drew Caskey
    {
        id: "drewCaskey",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/drew-caskey.webp",
        name: "Drew Caskey",
        title: "Assistant Director of Ticketing",
        email: "dcaskey4@huskers.com",
        phone: "402-472-3111",
    },

    // Grace Fahleson
    {
        id: "graceFahleson",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/grace-fahleson.webp",
        name: "Grace Fahleson",
        title: "Assistant Director of Ticket Sales",
        email: "gfahleson2@huskers.com",
        phone: "402-472-3119",
        bio: html`
            <p>Grace Fahleson joined the Nebraska Athletic Department in September 2025 as an Assistant Director of Ticket Sales.</p>
            <p>
                In her role, Fahleson assists with ticketing operations, sales, and donor relations, working to ensure fans and season ticket holders enjoy a seamless and positive experience with
                Husker Athletics. She works closely with internal staff, donors, and the community to provide exceptional service and support on game days and throughout the year.
            </p>
            <p>
                Fahleson has built a strong foundation in college athletics through roles with both Nebraska Athletics and the SEC. She served as a Marketing & Fan Engagement Intern with Nebraska
                Athletics in 2024-2025, where she developed game day scripts, coordinated promotions and sponsor activations, and contributed to advertising content. She also gained championship-level
                experience as a Marketing & Corporate Partnership Intern with the SEC in 2024, supporting sponsor activations, hospitality operations, and event logistics. Earlier in her career, she
                worked as a Ticketing and Development Student Worker with Nebraska Athletics in 2022.
            </p>
            <p>
                A Lincoln native, Fahleson earned her bachelor's degree in sports media and communication from the University of Nebraska-Lincoln in 2025 and takes pride in continuing to serve Husker
                fans while contributing to the success of Husker Athletics.
            </p>
        `,
    },
    // Craig Lucas
    {
        id: "chrisLucas",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/lucas-craig.webp",
        name: "Craig Lucas",
        title: "Assistant Director of Ticket Sales",
        email: "clucas7@huskers.com",
        phone: "402-472-3309",
        bio: html`
            <p>Craig Lucas joined Nebraska Athletics as Assistant Director of Ticket Sales in September of 2025.</p>
            <p>
                In his role Lucas assists with ticketing operations, sales, and donor relations, working to ensure fans and season ticket holders enjoy a seamless and positive experience with Huskers
                Athletics. He works closely with internal staff, donors, and the community to provide exceptional service and support on game days and throughout the year.
            </p>
            <p>
                Prior to the Huskers, Lucas served as an Intern with the University of Louisville athletics from 2023-2025. There he worked in many departments, Louisville football recruiting,
                facilities, and The Cardinal Athletic Fund. With CAF he gained hands on experience with donor relations, hospitality, and season ticket renewals for all ticketed sports.
            </p>
            <p>Craig, a native of Louisville, Kentucky, graduated from The University of Louisville in 2025 with a bachelor's degree in sports administration.</p>
        `,
    },
    // Noah Tassello
    {
        id: "noahTassello",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/noah-tassello.webp",
        name: "Noah Tassello",
        title: "Assistant Director of Ticket Sales",
        email: "ntassello2@huskers.com",
        phone: "402-472-3118",
        bio: html`
            <p>Noah Tassello joined the Nebraska Athletic Department in September 2025 as an Assistant Director of Ticket Sales.</p>
            <p>
                Tassello supports ticketing operations and sales, helping ensure fans have a smooth and enjoyable experience across all Huskers venues. Tassello previously worked in the Nebraska
                Athletic Ticket Office as a student worker while pursuing his degree at the University of Nebraska-Lincoln.
            </p>
            <p>Originally from Papillion, Neb., Tassello graduated in May 2025 with a degree in Sports Media and Communication and Advertising and Public Relations and Psychology minor.</p>
        `,
    },
    // Kara Timmons
    {
        id: "karaTimmons",
        dept: "ticketing",
        image: "assets/media/pages/about-us/staff/kara-timmons.webp",
        name: "Kara Timmons",
        title: "Assistant Director of Ticketing",
        email: "ktimmons3@huskers.com",
        phone: "402-472-3111",
        bio: html`
            <p>Kara Timmons joined Nebraska Athletics in July of 2026 as the assistant director of ticketing. Timmons oversees ticket operations for soccer, wrestling and softball.</p>
            <p>
                Prior to the Huskers, Timmons served Sam Houston State as the assistant director of ticket operations from August 2024 until July 2026 where she oversaw the ticket operations for
                soccer, volleyball, men's basketball and baseball.
            </p>
            <p>Timmons worked as a ticketing intern at the University of Maryland and was the ticket liaison for volleyball and women's lacrosse prior to her time at Sam Houston State.</p>
            <p>Timmons, a native of Hagerstown, Maryland, graduated from the University of Northwestern Ohio in 2020 with a bachelor's degree in sport marketing and management.</p>
        `,
    },
];
